export default [
    { id: 'start' },
    { id: 'sex-birthday-height' },
    { id: 'weight' },
    { id: 'goal' },
    { id: 'activity-level' },
    { id: 'start-date' },
    { id: 'finish' },
];
